import { Component, ComponentInterface, h, Prop } from '@stencil/core';

declare const assetPath;
declare const iconSheet;

@Component({
  tag: 'kdx-icon',
  shadow: false,
})
export class StIcon implements ComponentInterface {

  @Prop() cssClass: string;
  @Prop() icon: string;

  render() {
    return (
      <svg class={this.cssClass}>
        <use xlinkHref={`${assetPath}${iconSheet}#${this.icon}`}></use>
      </svg>
    );
  }

}
